import { render, staticRenderFns } from "./SubscriptionPopupModal.vue?vue&type=template&id=65d2b84c&scoped=true"
import script from "./SubscriptionPopupModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionPopupModal.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPopupModal.vue?vue&type=style&index=0&id=65d2b84c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d2b84c",
  null
  
)

export default component.exports